import { AssetsPoUnitRequest } from '@gtpl/shared-models/common-models';
import { GetAllAssetsPoResponse } from '@gtpl/shared-models/procurement-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { AssetsPoService } from './assets-po.service';
import { AssetsPoDtO } from './dto/assets-po-dto';
import { AssetsPoByIdDto } from './dto/assets-po-id-dto';

@ApiTags('assets-po')
@Controller('assets-po')
export class AssetsPoController {
    constructor(private assetspoService: AssetsPoService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/CreateAssets')
    async CreateAssets(@Body() details: AssetsPoDtO) {
    //     try {
    //         return await this.assetspoService.CreateAssets(details);

    //     } catch (error) {
    //         throw error
    //     }
    }

   

    @Post('getRecordByAssetsPoId')
    async getRecordByAssetsPoId(@Body() id: AssetsPoByIdDto) {
        try {
            return await this.assetspoService.getRecordByAssetsPoId(id.purchaseOrderId);
        } catch (error) {
            throw error
        }
    }
    @Post('getAllAssetsPo')
    async getAllAssetsPo() {
        try {
            return await this.assetspoService.getAllAssetsPo();
        } catch (error) {
            throw error
        }
    }

    @Post('getAllAssetsPoDetailsInfo')
    async getAllAssetsPoDetailsInfo(@Body() req?: AssetsPoUnitRequest): Promise<GetAllAssetsPoResponse> {
        try {
            return await this.assetspoService.getAllAssetsPoDetailsInfo(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllAssetsPoResponse, error);
        }
    }
}
